import DescriptionDetail from "src/shared/components/data-display/description-detail/DescriptionDetail"
import Drawer from "src/shared/components/layout/drawer/Drawer"
import { RegistroHuespedesDetailProps } from "./RegistroHuespedesDetail.type"
import "./RegistroHuespedesDetail.css"

const emptyValue = "-"

const formatFechaHora = (fecha?: string | null, hora?: string | null) =>
    [fecha, hora].filter(Boolean).join(" ") || emptyValue

const RegistroHuespedesDetail = ({ isOpen, onClose, data }: RegistroHuespedesDetailProps): JSX.Element => {
    return (
        <Drawer
            placement={"right"}
            bar={false}
            visible={isOpen}
            withCloseButton
            onClose={onClose}
            testId="registro-huespedes-detail"
        >
            <div className="registro-huespedes-detail__head">
                <p className="registro-huespedes-detail__title">Registro de huésped</p>
                {!!data?.folio_ticket && <p className="registro-huespedes-detail__subtitle">{data.folio_ticket}</p>}
            </div>
            <div className="registro-huespedes-detail__body">
                <div className="registro-huespedes-detail__description">
                    <DescriptionDetail
                        icon={"ShieldUserFill"}
                        label={"Tipo de huésped"}
                        value={data?.tipo_huesped || emptyValue}
                    />
                    <DescriptionDetail icon={"Gender"} label={"Género"} value={data?.genero || emptyValue} />
                    <DescriptionDetail
                        className={"registro-huespedes-detail__value--full"}
                        icon={"accountBoxFill"}
                        label={"Nombre"}
                        value={data?.nombre || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"calendarEvent"}
                        label={"Fecha de nacimiento"}
                        value={data?.fecha_nacimiento || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"FileListFill"}
                        label={"Documento"}
                        value={data?.tipo_documento || emptyValue}
                    />
                    <DescriptionDetail
                        icon={"HashWhite"}
                        label={"ID"}
                        value={data?.numero_documento || emptyValue}
                    />
                    <DescriptionDetail icon={"UserContactsFill"} label={"CURP"} value={data?.curp || emptyValue} />
                    <DescriptionDetail
                        icon={"calendarChecked"}
                        label={"Fecha y hora de entrada"}
                        value={formatFechaHora(data?.fecha_entrada, data?.hora_entrada)}
                    />
                    <DescriptionDetail
                        icon={"Calendar2Fill"}
                        label={"Fecha y hora de salida"}
                        value={formatFechaHora(data?.fecha_salida, data?.hora_salida)}
                    />
                    <DescriptionDetail icon={"buildingFill"} label={"Habitación"} value={data?.habitacion || emptyValue} />
                    <DescriptionDetail
                        icon={"Earth"}
                        label={"Nacionalidad"}
                        value={data?.nacionalidad || emptyValue}
                    />
                    <DescriptionDetail
                        className={"registro-huespedes-detail__value--full"}
                        icon={"MapPinFill"}
                        label={"Dirección"}
                        value={data?.direccion || emptyValue}
                    />
                </div>
            </div>
        </Drawer>
    )
}

export default RegistroHuespedesDetail
